import React, { Component,useEffect,useState } from 'react';
import { Button, Input, message, Spin, Row, Col, Modal, Form } from "antd";
import { setFEWalletParams, setFEWalletParam,getFEWalletParams } from 'central-payment/platform.pay.config';
// import { setFEWalletParams, setFEWalletParam,getFEWalletParams } from '../../Central-Payment/platform.pay.config';
import Deposit from '$Deposits/Web/deposit'
import { getE2BBValue,showResultModal } from "$ACTIONS/helper";
import HostConfig from "$ACTIONS/Host.config";
import { APISETS, API8SETS } from "$ACTIONS/TLCAPI";
import { get, post } from "$ACTIONS/TlcRequest";
import { connect } from "react-redux";
import { translate } from "$ACTIONS/Translate";
import {realyNameReg} from "$ACTIONS/reg";
import { getMemberInfo, setMemberInfo } from "$DATA/userinfo";
import { userCenterActions } from "$STORE/userCenterSlice";
import AddBankCard from "@/BankAccount/AddBankCard";
import Router from 'next/router';
import Announcement from '@/Announcement/';
import DepositUSDTLesson from "@/DepositLesson/CTC";
import DepositPHCLesson from "@/DepositLesson/PHC";
import {replaceMultipleSpacesWithSingle} from "$ACTIONS/util";
import { fetchMemberSelfExlusionStatus } from '../../store/userCenterSlice';
import { promotionActions } from '../../store/promotionSlice';
import RealNameVerify from "../Verification/RealNameVerify";
import { getSeonSession } from '../../actions/util';

const { Item } = Form;
const { LocalHost, HostApi, BffscHostApi } = HostConfig.Config;
const febffsc = [
    "/api/Member",
    "/api/Bonus/v2.0",
    "/api/Payment/DepositAccountByAmount",
    "/api/Payment/BindReverseDepositAccount"
];
const apiVersion8 = [
    "/api/Member",
    "/api/Bonus/v2.0",
];
class DepositPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadinglogin: '',
            show: false,
            nameModalVisible:false,
            showAddCard:false,
            lessonModal: false,
            depositLessonTab: 2,
            phcLessonModal: false,
            nameModalLoad:false,
            realyNameBtn: true,
            showFillInName: false,
            shouldVerifyRealName: false,
        };
        const { setLoading ,dialogTabKey, OWSelectedBonus} = this.props;
        const { bonusData, promoTitle } = this.props.selectedBonus || {};
        const isBonusValid = JSON.stringify(bonusData) !== "{}";
        console.log("🚀 ~ DepositPage ~ constructor ~ dialogTabKey:", dialogTabKey)
        console.log("🚀 ~ DepositPage ~ constructor ~ dialogTabKey?.currentPayValue:", this.props)
        console.log("🚀 ~ DepositPage ~ constructor ~ dialogTabKey?.OWSelectedBonus:", OWSelectedBonus?.bonusData?.account)
        const bonusId = dialogTabKey?.bonusId && String(dialogTabKey?.bonusId) ||"";
        const methodCode = dialogTabKey?.currentPayValue ?? "";
        this.privateParams = {
            device: 'WEB',
            platformType: 'F1',
            languageType: 'M3',
            domainName: LocalHost,
            successUrl: LocalHost,
            siteId: 37,
            ActiveMethods: methodCode,//指定存款,默认第一个
            bonusId: isBonusValid ? bonusData?.id : undefined,
            bonusName: isBonusValid ? promoTitle : undefined,
            depositingWallet: OWSelectedBonus?.bonusData?.account ? OWSelectedBonus?.bonusData?.account : undefined, // 注意didMount也有一個會覆蓋depositingWallet
            firstName: 'zzz',
            paymentBalance: PaymentBalance? PaymentBalance: 0,
            balanceInfo: this.props?.balanceInfo?.totalBalance || 0,
            BackClick: () => {this.nextStep()},
            BackClick: () => {
                this.setState({ show: false })
                setTimeout(() => {
                    Router.push("/");
                }, 1500);
            },
            BackMyPromo: () => {
            this.props.onCancel(); //關閉錢包彈窗
            this.props.additionalCallback && this.props.additionalCallback();
            if (Router.router.pathname === "/promotions") {
                this.props.setBackPromotionPage(true);
            }
            setTimeout(() => {
                Router.push("/promotions");
            }, 1500);
            },
            LivechatClick: () => { global.PopUpLiveChat() },
            goAddBankInfo: (callback, bankLength) => {this.addBankCardModal(callback, bankLength)},//添加银行
            HistoryClick: (type = 'Deposit') => {this.navigationPage("records") },//type = Deposit存款记录
            goRecord:(type = 'Deposit',method)=>{ console.log('method:',method),this.navigationPage("records")},
            ApiGet: (url) => {
                const host = febffsc.includes(url.split("?")[0])? BffscHostApi : HostApi;
                const apiset = (apiVersion8.includes(url.split("?")[0]) ? API8SETS : APISETS).slice(1);
                return get(host + url + apiset);
            },
            ApiPost: (url, postdata = '') => {
                const host = febffsc.includes(url.split("?")[0])? BffscHostApi : HostApi;
                const apiset = (apiVersion8.includes(url.split("?")[0]) ? API8SETS : APISETS).slice(1);
                return post(host + url + apiset, postdata);
            },
            goVerifyContact: () => {},
            goFinishKYCInfo: () => {this.navigationPage("uploadFiles")},//KYC
            goFinishMemberInfo: () => {
                this.setState({ showFillInName: true });
            },
            toastTip: {
                loading: () => { setLoading && setLoading(true) },
                hide: () => { setLoading && setLoading(false) },
                success: (msg) => { message.success(msg) },
                error: (msg) => { message.error(msg) },
            },
            openTutorial: (v) => {
                this.openTutorial(v)
            },
            openService: () => { global.PopUpLiveChat() },
            webPiwikEvent:(eventCategory, action, name, number="", customVariableArr = [])=>{Pushgtagdata(eventCategory, action, name, number, customVariableArr)},
            webPiwikUrl:(url,trackingTitle="")=>{Pushgtagpiwikurl(url,trackingTitle)},
            appPiwikEvent: () => {},
            appPiwikUrl: () => {},
            getSeonSession: getSeonSession
        }
        setFEWalletParams(this.privateParams);
        this.callMemberBanks=null;
        this.memberbanksLength = 0;
    }

    async componentDidMount() {
        await this.props.fetchMemberSelfExlusionStatus();
        console.log("🚀 ~ DepositPage ~ componentDidMount ~", this.props);
        setFEWalletParam('e2Backbox', getE2BBValue() || '')
        setTimeout(() => {
            this.setState({ show: true })
        }, 300);

        if(!!sessionStorage.getItem("promoDeposit")){
            const itemPropotionInfo = JSON.parse(sessionStorage.getItem("promoDeposit"));
            console.log("🚀 ~ DepositPage ~ componentDidMount ~ itemPropotionInfo:", itemPropotionInfo)
            console.log("🚀 ~ DepositPage ~ componentDidMount ~ itemPropotionInfo:",   !!itemPropotionInfo?.depositingWallet)
            this.privateParams = {
                ...this.privateParams,
                bonusId: itemPropotionInfo.bonusId,
                bonusRuleGroupId:itemPropotionInfo.bonusRuleGroupId,
                bonusName: itemPropotionInfo.bonusTitle,
                depositingWallet: !!itemPropotionInfo?.depositingWallet ? itemPropotionInfo?.depositingWallet : itemPropotionInfo.bonusProduct,
            }
        }
        if(this.props?.memberInfo?.firstName?.trim() === ""){
            this.setState({ shouldVerifyRealName: true });
        }
        setFEWalletParams(this.privateParams)
        const depositedMembers = JSON.parse(localStorage.getItem("isDeposited") || "[]");
        const isMemberDeposited = depositedMembers.includes(this.props?.memberInfo?.userName);
        if (this.props?.memberInfo?.isDeposited == 1 && !isMemberDeposited) {
            localStorage.setItem("isDeposited", JSON.stringify([...depositedMembers, this.props?.memberInfo?.userName]));
            global?.fbqTag && fbqTag('firstrecharge');
        }
    }
    componentDidUpdate(prevProps, prevState) {}
    

    componentWillUnmount() {
        this.setState = () => false;
        this.privateParams = null;
        this.callMemberBanks = null;
        this.memberbanksLength = 0
        getFEWalletParams();
    }

    /**
     * 充值完成后页面的按钮
     */
    nextStep =()=> {
        if(!!sessionStorage.getItem("promoDeposit")){
            sessionStorage.removeItem("promoDeposit")
        }
        this.props.onCancel();
        if(!global.location.pathname.includes("/vn/promotions")){
            Router.push("/promotions")
        }
    }

    openTutorial =(v)=> {
        this.setState({
            lessonModal: v && v === "DCTC",
            phcLessonModal: v && v === "DPHC"
        })
    }
    /**
     * 跳转page
     * @param {*} key 
     */
    navigationPage=(key)=>{
        switch(key){
            case "records":
                if (~global.location.pathname.indexOf("/vn/transaction-record")) {
                    this.props.setRefreshCurrentPage("deposit");
                    this.props.onCancel();
                } else{
                    this.props.changeUserCenterTabKey(key);
                    Router.push("/transaction-record");
                }
                break;
            case "uploadFiles":
                if (~global.location.pathname.indexOf("/vn/me/upload-files")) {
                    this.props.onCancel();
                } else{
                    this.props.changeUserCenterTabKey(key);
                    Router.push("/me/upload-files");
                }
                break;
            default:
                break;
        }
    }

    handleSubmit = ()=>{
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({nameModalLoad:true})
                setMemberInfo(
                    {
                        key: "firstName",
                        value1: values.realName.trim(),
                    },
                    (res) => {
                        this.setState({nameModalLoad:false})
                        global.Pushgtagpiwikurl && global.Pushgtagpiwikurl("kyc​","KYC​");
                        Pushgtagdata("KYC","Submit Real Name / Go to Deposit Page","KYC_S_RealName​",
                            res?.isSuccess && res.result ? 2 : 1,
                            [
                                {customVariableKey: res?.isSuccess && res.result ? false : "KYC_S_RealName​​" ,
                                customVariableValue: res?.isSuccess && res.result ? false : `Error Msg: ${res?.errors[0]?.message||"fail"}`},
                            ]
                        )
                        if (res && res.isSuccess && res.result?.code === "MEM00075") {
                            showResultModal(translate("认证成功"),true,1501,'otp','authentication-succeeded');
                            this.setState({nameModalVisible: false})
                            getMemberInfo((result)=>{
                                this.props.updateMemberInfo(result)
                            },true)
                        } else {
                            showResultModal(translate("失败"),false,1501,'otp','authentication-succeeded');
                        }
                    }
                );
            }
        })
    }
    /**
     * 添加银行卡
     */
    addBankCardModal=(callback, bankLength)=>{
        this.setState({showAddCard: true})
        this.callMemberBanks = callback;
        this.memberbanksLength = bankLength;
    }
    /**
     * usdt教程 tab切换
     * @param {*} n 
     */
    handleChangeDepositLessonTab = (n) => {
        this.setState({ depositLessonTab: n });
    };
    render() {
        const {
            nameModalVisible,
            showAddCard,
            nameModalLoad,
            realyNameBtn
        } = this.state;
        const { getFieldDecorator, getFieldError,setFieldsValue,getFieldsValue,realyName} = this.props.form;
        return (
            <React.Fragment>
                <Loading />
                <div>
                    {
                        this.state.show && <Deposit triggerFor="deposit" />
                    }
                </div>
                <Modal
                    width={"400px"}
                    centered={true}
                    visible={this.state.shouldVerifyRealName}
                    title={translate("需要身份验证")}
                    okText={translate("立即验证")}
                    cancelText={translate("稍后认证")}
                    closable={true}
                    className="modal-pubilc finnInNameModal"
                    onOk={() => {
                        this.setState({shouldVerifyRealName: false }, () => {
                            this.setState({ nameModalVisible: true });
                        });
                    }}
                    onCancel={() => {
                    this.setState({ showFillInName: false })
                    this.props.additionalCallback && this.props.additionalCallback()
                    }}
                >
                    <p style={{ marginBottom: "20px", fontWeight: "bold" }}>
                        {translate("为了确保您的账户安全，请完成实名认证后进行充值")}
                    </p>
                </Modal>
                {/* 紧急公告弹窗 */}
                {this.props.isDisableFromSelfExclude !== null && 
                !this.props.isDisableFromSelfExclude && 
                !this.state.nameModalVisible &&
                !this.state.shouldVerifyRealName &&
                <Announcement 
					optionType="Deposit"
                    isDisableFromSelfExclude={this.props.isDisableFromSelfExclude}
				/>}
                <RealNameVerify
                    visible={this.state.nameModalVisible}
                    closeModal={() => {
                        this.setState({ nameModalVisible: false });
                        this.props.onCancel();
                    }}
                    correctMemberInfo={() => {
                        getMemberInfo((result)=>{
                            this.props.updateMemberInfo(result)
                        },true)
                    }}
                    isNext={false}
                />
                {showAddCard && <AddBankCard
                    visible={showAddCard}
                    closeModal={() => {
                        this.setState({ showAddCard: false });
                    }}
                    alreadyBindBanks={this.memberbanksLength > 0 ? [this.memberbanksLength] :[]}
                    getMemberBanksList={()=>this.callMemberBanks && typeof this.callMemberBanks === "function" && this.callMemberBanks()}
                />}
                {/* usdt 充值教程 */}
                <Modal
                    footer={null}
                    maskClosable={true}
                    onCancel={()=>{this.setState({lessonModal: false})}}
                    visible={this.state.lessonModal}
                    width={600}
                    title={translate("usdt充值教程")}
                    closable={false}
                >
                    <DepositUSDTLesson
                        onhandleCancel={()=>{this.setState({lessonModal: false})}}
                        tabNum={this.state.depositLessonTab}
                        handleChangeDepositLessonTab={
                            this.handleChangeDepositLessonTab
                        }
                    />
                </Modal>
                {/* PHC 充值教程 */}
                <Modal
                    footer={null}
                    maskClosable={true}
                    onCancel={()=>{this.setState({phcLessonModal: false})}}
                    visible={this.state.phcLessonModal}
                    width={600}
                    title={translate("刮刮卡充值教程")}
                    closable={false}
                >
                    <DepositPHCLesson
                        onhandleCancel={()=>{this.setState({phcLessonModal: false})}}
                    />
                </Modal>
            </React.Fragment>
        );
    }
}

export class Toast {
    static loading(title, time) {
        Loading.setContentLarge(title, time)
    }
    static hide() {
        Loading.clearContent()
    }

}

//loading
let ToasViewInstance = null;
class Loading extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalVisible: '',
        };
        this.timeOut = null
        ToasViewInstance = this
    }
    componentWillUnmount() {
        this.timeOut && clearTimeout(this.timeOut)
        this.timeOut = null
        ToasViewInstance = null
    }
    static setContentLarge(tips = 'Loading...', time = 20) {
        ToasViewInstance && ToasViewInstance.show(tips, time)
    }
    show = (tips, time) => {
        this.setState({ modalVisible: tips })
        this.timeOut = setTimeout(() => {
            this.setState({ modalVisible: '' })
            this.timeOut && clearTimeout(this.timeOut)
            this.timeOut = null
        }, time * 1000);
    }
    static clearContent() {
        ToasViewInstance && ToasViewInstance.hide()
    }
    hide = () => {
        this.setState({ modalVisible: '' })
        this.timeOut && clearTimeout(this.timeOut)
        this.timeOut = null
    }
    render() {
        const { modalVisible } = this.state;
        return (
            <Modal
                width="135px"
                keyboard={false}
                closable={false}
                className="Spin_modal"
                footer={null}
                visible={Boolean(modalVisible)}
                maskClosable={false}
            >
                <Spin tip={modalVisible || 'Loading...'} />
            </Modal>
        )
    }
}

const mapStateToProps = (state) => ({
    isDisableFromSelfExclude: state.userCenter.isDisableFromSelfExclude, // Map the state to props
    selectedBonus: state.promotion.selectedBonus,
    memberInfo: state.userCenter.memberInfo,
    balanceInfo : state.userCenter.balanceInfo,
    OWSelectedBonus: state.promotion.OWSelectedBonus,
});

const mapDispatchToProps = function (dispatch) {
    return {
        changeUserCenterTabKey:(tabkey)=>{
            dispatch(userCenterActions.changeUserCenterTabKey(tabkey))
        },
        updateMemberInfo:(value)=>{
            dispatch(userCenterActions.setMemberInfo(value))
        },
        setRefreshCurrentPage:(v)=>{
            dispatch(userCenterActions.setRefreshCurrentPage(v))
        },
        setBackPromotionPage: (status) =>
            dispatch(promotionActions.setBackPromotionPage(status))
        ,
        checkSelfExclusion: (v) => {
            dispatch(userCenterActions.setIsDisableFromSelfExclude(v))
        },
        fetchMemberSelfExlusionStatus: () => dispatch(fetchMemberSelfExlusionStatus()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: "DepositPage" })(DepositPage));
